// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.async.AsyncMessage
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

export class AsyncMessage {
  static createAsyncMessage(message, queueName) {
    const retVal = new AsyncMessage();
    retVal.initAsyncMessage(message, queueName);
    return retVal;
  }

  /** Do NOT invoke directly, instead use strongly typed createAsyncMessage factory method */
  constructor() {}

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawada.AsyncMessage";
  }
  initFromJson(json, deserializeContext) {
    this.initAsyncMessage(json.message != null ? json.message : null, json.queueName != null ? json.queueName : null);
  }
  initAsyncMessage(message, queueName) {
    this._message = message;
    this._queueName = queueName;
  }
  toTSOG(result, serializeContext) {
    const retVal = result;
    retVal["message"] = this._message;
    retVal["queueName"] = this._queueName;
    return retVal;
  }
  get message() {
    return this._message;
  }
  set message(value) {
    this._message = value;
  }
  get queueName() {
    return this._queueName;
  }
  set queueName(value) {
    this._queueName = value;
  }
}
//# sourceMappingURL=AsyncMessage.js.map
